<!--
대금상환 건별 정산확정 모달 (TASK-161 사이클 14 #15 — 결정 49 f, 총괄 목록 불일치 카드 「정산확정」)
------------------------------------
 - 페이지당 1 인스턴스. 카드 「정산확정」 버튼 (.cdp-btn-confirm — 창고지급완료 건 상시, 사이클 15 #20) 이 open(row) 로 데이터 주입
     row = page.cod_rows[id] (CodPaymentIndexTrait::codRowsJson)
 - 표시 = 오더번호 · 대금상환금액 · 창고지급(실제) · 차액 (창고지급(실제) − 대금상환금액 — 0 아니면 빨강 .is-nonzero) · 소속 상품 카드 (공용 prod-cards readonly)
     사이클 16 #27: 오더번호 · 트래킹 · 금액 = 공용 컨텍스트 헤더 app-buy-order-ctx (대금상환금액 · 창고지급(실제) 큰 글자 · 차액 빨강 · 회원사) · 상품 = 간략 행
 - 정산확정금액 input = 창고지급(실제) 프리필 (결정 49 f) → PATCH /admin/cod-payments/{id}/confirm (settle_amount)
 - 서버 = ConfirmLogic 건별 경로 (부적합 = 문구 그대로 alert) · 성공 = 서버 msg alert 후 새로고침
 - E2E 셀렉터 = .cdp-confirm-popup · .cdp-confirm-req · .cdp-confirm-paid · .cdp-confirm-diff · .cdp-confirm-amount · .cdp-confirm-submit
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-confirm-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">정산확정 (건별)</h3>

            <!-- 사이클 16 #27 — 컨텍스트 헤더 (공용 app-buy-order-ctx: 해외오더번호 · 트래킹 칩 · 대금상환금액/창고지급(실제) 큰 글자 · 차액 (≠0 빨강 .is-nonzero) · 회원사) -->
            <app-buy-order-ctx v-if="row" :code="row.buy_order_code || ''" :trackings="row.tracking_nos || []" :items="ctxItems"></app-buy-order-ctx>

            <div class="uk-margin-small cdp-popup-prods" v-if="row && row.prods">
                <div class="uk-text-muted cdp-popup-prods__hd">소속 상품 {{ row.prods.length }}건</div>
                <div class="cdp-popup-prods__wrap">
                    <app-buy-order-prod-cards :prods="row.prods" readonly card-class="cdp-popup-prod-card"></app-buy-order-prod-cards>
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">정산확정금액 <span v-if="row && row.currency">({{ row.currency }})</span> — 기본값 = 창고지급(실제)</label>
                <div class="uk-form-controls">
                    <input class="uk-input cdp-confirm-amount" type="text" v-model.trim="inputSettleAmount" placeholder="정산확정금액"/>
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary cdp-confirm-submit" type="button"
                        :disabled="busy || inputSettleAmount === ''" @click="submit">정산확정</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from './popup-mixin';

    export default {
        mixins: [CodPopupMixin],
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                inputSettleAmount: '',
            };
        },
        computed: {
            // 컨텍스트 헤더 키-값 (사이클 16 #27 — E2E 셀렉터 .cdp-confirm-req · .cdp-confirm-paid · .cdp-confirm-diff 는 값 요소 class 로 보존)
            ctxItems() {
                if (! this.row) {
                    return [];
                }
                return [
                    {k: '대금상환금액', v: this.reqAmountText, big: true, cls: 'cdp-confirm-req'},
                    {k: '창고지급(실제)', v: this.paidAmountText, big: true, cls: 'cdp-confirm-paid'},
                    {k: '차액 (창고지급(실제) − 대금상환금액)', v: this.diffText, red: this.diffNonZero, cls: 'cdp-confirm-diff' + (this.diffNonZero ? ' is-nonzero' : '')},
                    {k: '회원사', v: this.row.user_nick + (this.row.user_mailbox ? ' · ' + this.row.user_mailbox : '')},
                ];
            },

            // 차액 ≠ 0 일 때만 빨간 강조 (사이클 15 #20 — 「정산확정」 버튼 상시 → 일치 건 차액 0 은 중립 표기)
            diffNonZero() {
                if (! this.row) {
                    return false;
                }
                let req = parseFloat(this.normalize(this.row.req_amount));
                let paid = parseFloat(this.normalize(this.row.paid_amount));
                if (isNaN(req) || isNaN(paid)) {
                    return false;
                }
                return Math.round((paid - req) * 100) / 100 !== 0;
            },
            // 차액 = 창고지급(실제) − 대금상환금액 (부호 표시)
            diffText() {
                if (! this.row) {
                    return '-';
                }
                let req = parseFloat(this.normalize(this.row.req_amount));
                let paid = parseFloat(this.normalize(this.row.paid_amount));
                if (isNaN(req) || isNaN(paid)) {
                    return '-';
                }
                let diff = Math.round((paid - req) * 100) / 100;
                let text = this.priceText(Math.abs(diff), this.row.currency);
                return (diff > 0 ? '+' : (diff < 0 ? '−' : '')) + text;
            },
        },
        methods: {
            open(row) {
                this.row = row || null;
                // 결정 49 f — 정산확정금액 기본값 = 창고지급(실제)
                this.inputSettleAmount = row ? this.normalize(row.paid_amount) : '';
                this.show();
            },

            submit() {
                if (this.busy || ! this.row || this.inputSettleAmount === '') {
                    return;
                }
                this.request('patch', '/admin/cod-payments/' + this.row.id + '/confirm', {
                    settle_amount: this.inputSettleAmount,
                }).then(this.done);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // (구 금액 3칸 상자 .cdp-confirm-amounts = 사이클 16 #27 공용 컨텍스트 헤더로 대체 — 차액 빨강 = 헤더 item red, 값 요소 .cdp-confirm-diff.is-nonzero)

    // 소속 상품 — 스크롤 = 공용 목록 안 (사이클 16 #27)
    .cdp-popup-prods__hd {
        margin-bottom: 4px;
    }
</style>
